import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { AutomationVariableMenuComponent } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.component';
import { insertVariable } from '../../../../../common/components/automation-variable-menu/automation-variable-menu.service';
import { ActivityHotnessService, Hotness } from '../../../../../data-services/activity-hotness.service';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-create-business-activity-panel',
  templateUrl: './create-business-activity-panel.component.html',
  styleUrls: ['./create-business-activity-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationVariableMenuComponent,
  ],
})
export class CreateBusinessActivityPanelComponent extends CommonActionPanelComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  loadingForm = true;
  hotnessOptions = this.hotnessService.listHotnessEvents();

  selectedHotness$$ = new BehaviorSubject<Hotness>(null);
  selectedHotness$: Observable<Hotness> = this.selectedHotness$$.asObservable();

  destroyed$$ = new Subject<void>();

  constructor(
    protected readonly hotnessService: ActivityHotnessService,
    private readonly ref: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.form = new UntypedFormGroup({
      hotness_rating: new UntypedFormControl(jsonData.activity_type || ''),
      activity_detail: new UntypedFormControl(jsonData.activity_detail || '', Validators.required),
    });

    this.selectedHotness$$.next(this.hotnessService.getHotness(jsonData.activity_type || ''));
    this.form
      .get('hotness_rating')
      .valueChanges.pipe(
        takeUntil(this.destroyed$$),
        tap((value) => this.selectedHotness$$.next(this.hotnessService.getHotness(value))),
      )
      .subscribe();

    // Since there's nothing asynchronous about this form, saving is enabled on initialization.
    this.savingEnabled = true;

    this.loadingForm = false;
    this.ref.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroyed$$.next();
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    if (!this.form) {
      return jsonData;
    }
    jsonData.activity_detail = this.form.controls.activity_detail.value;
    jsonData.activity_type = this.form.controls.hotness_rating.value;
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.form];
  }

  isFormValid(): boolean {
    return this.form.valid;
  }

  insertVariable(elementID: string, control: AbstractControl, variable: string): void {
    insertVariable(elementID, control, variable);
  }
}
